module.exports = __webpack_public_path__ + "img/welcome_img1.40f706ef.png";